(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sq-advent-doors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sq-advent-doors')) {
    class SqAdventDoors extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.opened = 0;
        this.revealAfter = Number(this.dataset.revealAfter) || 3;
        this.status = this.querySelector('.sq-doors__status');
        this.cta = this.querySelector('.sq-doors__cta');

        this.querySelectorAll('.sq-doors__door').forEach((door) => {
          door.addEventListener('click', () => this.open(door), { signal: this.controller.signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      open(door) {
        if (door.classList.contains('is-open')) {
          // Un second clic fait rebondir le squishy.
          door.classList.remove('is-wiggle');
          void door.offsetWidth;
          door.classList.add('is-wiggle');
          return;
        }
        door.classList.add('is-open');
        door.setAttribute('aria-pressed', 'true');
        door.setAttribute('aria-label', `Case ouverte : ${door.dataset.name}`);
        this.opened += 1;
        if (this.status) this.status.textContent = `Vous avez trouvé ${door.dataset.name} !`;

        if (this.opened >= this.revealAfter && this.cta?.hidden) {
          this.cta.hidden = false;
          requestAnimationFrame(() => this.cta.classList.add('is-visible'));
        }
      }
    }
    customElements.define('sq-advent-doors', SqAdventDoors);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sq-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sq-countdown')) {
    class SqCountdown extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target);
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });
        if (Number.isNaN(this.target)) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const remaining = Math.max(0, this.target - Date.now());
        const total = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(total / 86400),
          hours: Math.floor((total % 86400) / 3600),
          minutes: Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };
        for (const [unit, value] of Object.entries(parts)) {
          const el = this.values[unit];
          if (!el) continue;
          const text = String(value).padStart(2, '0');
          if (el.textContent === text) continue;
          el.textContent = text;
          el.classList.remove('is-tick');
          void el.offsetWidth;
          el.classList.add('is-tick');
        }
        if (remaining === 0) {
          clearInterval(this.timer);
          const done = this.querySelector('.sq-countdown__done');
          if (done) {
            done.hidden = false;
            this.querySelector('.sq-countdown__timer').hidden = true;
          }
        }
      }
    }
    customElements.define('sq-countdown', SqCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sq-squeeze"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sq-squeeze')) {
    const N = 28;
    const CX = 200;
    const BASE_Y = 300; // le squishy est posé sur ce "sol"
    const RX = 140;
    const RY = 118;

    const shade = (hex, amount) => {
      const n = parseInt(hex.slice(1), 16);
      const r = Math.max(0, Math.min(255, (n >> 16) + amount));
      const g = Math.max(0, Math.min(255, ((n >> 8) & 255) + amount));
      const b = Math.max(0, Math.min(255, (n & 255) + amount));
      return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    };

    class SqSqueeze extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.svg = this.querySelector('.sq-squeeze__svg');
        if (!this.svg) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.el = {
          body: this.svg.querySelector('[data-body]'),
          pleats: this.svg.querySelector('[data-pleats]'),
          shine: this.svg.querySelector('[data-shine]'),
          shadow: this.svg.querySelector('[data-shadow]'),
          eyeL: this.svg.querySelector('[data-eye-l]'),
          eyeR: this.svg.querySelector('[data-eye-r]'),
          glintL: this.svg.querySelector('[data-glint-l]'),
          glintR: this.svg.querySelector('[data-glint-r]'),
          open: this.svg.querySelector('[data-eyes-open]'),
          closed: this.svg.querySelector('[data-eyes-closed]'),
          mouth: this.svg.querySelector('[data-mouth]'),
          cheekL: this.svg.querySelector('[data-cheek-l]'),
          cheekR: this.svg.querySelector('[data-cheek-r]'),
          count: this.querySelector('[data-count]'),
          message: this.querySelector('[data-message]'),
        };
        this.messages = {
          1: 'Hihi, ça chatouille ! 😆',
          5: 'Encore, encore ! 🎁',
          10: 'Tu as la main squishy ✨',
          24: '24 pressions = 24 matins de bonheur 🎁',
          50: 'Champion·ne du squish ! 🏆',
          100: 'OK… il est officiellement ton meilleur ami 💖',
        };

        // Forme au repos : un dumpling (plus plat en bas, bombé en haut).
        this.points = [];
        for (let i = 0; i < N; i++) {
          const a = (i / N) * Math.PI * 2 - Math.PI / 2;
          const bottom = Math.sin(a) > 0;
          const rx = RX * (bottom ? 1.04 : 1);
          const ry = RY * (bottom ? 0.62 : 1);
          const x = Math.cos(a) * rx;
          const y = Math.sin(a) * ry;
          this.points.push({ rx: x, ry: y, x: CX + x, y: BASE_Y - RY * 0.62 + y, vx: 0, vy: 0 });
        }
        this.squash = 0; // 0 = repos, 1 = écrasé
        this.squashV = 0;
        this.stretch = 0;
        this.stretchV = 0;
        this.pointer = null;
        this.pressed = false;
        this.count = 0;
        this.setColor('#FFD6E0');

        const down = (event) => {
          event.preventDefault();
          this.svg.setPointerCapture?.(event.pointerId);
          this.pressed = true;
          this.pointer = this.toSvg(event);
          this.pressStart = this.pointer.x;
          this.onPress();
        };
        const move = (event) => {
          const p = this.toSvg(event);
          this.hover = p;
          if (this.pressed) this.pointer = p;
        };
        const up = () => {
          if (!this.pressed) return;
          this.pressed = false;
          this.pointer = null;
          // Petit "boing" au relâchement.
          this.squashV -= this.reduced ? 0 : 0.09;
        };
        this.svg.addEventListener('pointerdown', down, { signal });
        this.svg.addEventListener('pointermove', move, { signal });
        this.svg.addEventListener('pointerup', up, { signal });
        this.svg.addEventListener('pointercancel', up, { signal });
        this.svg.addEventListener('pointerleave', () => (this.hover = null), { signal });
        this.svg.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== ' ' && event.key !== 'Enter') return;
            event.preventDefault();
            if (event.repeat) return;
            this.pressed = true;
            this.onPress();
          },
          { signal }
        );
        this.svg.addEventListener(
          'keyup',
          (event) => {
            if (event.key === ' ' || event.key === 'Enter') up();
          },
          { signal }
        );

        this.querySelectorAll('.sq-squeeze__swatch').forEach((button) => {
          button.addEventListener(
            'click',
            () => {
              this.querySelectorAll('.sq-squeeze__swatch').forEach((b) => {
                b.classList.toggle('is-active', b === button);
                b.setAttribute('aria-checked', String(b === button));
              });
              this.setColor(button.dataset.color);
              this.squashV += 0.06; // petit sursaut de joie
            },
            { signal }
          );
        });

        // N'anime que lorsque la section est visible.
        this.visible = false;
        this.io = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.loop();
        });
        this.io.observe(this);
        this.render();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.io?.disconnect();
        cancelAnimationFrame(this.raf);
      }

      setColor(hex) {
        this.style.setProperty('--sq-body', hex);
        this.style.setProperty('--sq-body-dark', shade(hex, -38));
        this.svg.querySelector('[data-body-stop]')?.setAttribute('stop-color', hex);
        this.svg.querySelector('[data-body-dark]')?.setAttribute('stop-color', shade(hex, -38));
      }

      toSvg(event) {
        const pt = this.svg.createSVGPoint();
        pt.x = event.clientX;
        pt.y = event.clientY;
        const m = this.svg.getScreenCTM();
        return m ? pt.matrixTransform(m.inverse()) : { x: CX, y: 200 };
      }

      onPress() {
        this.count += 1;
        this.el.count.textContent = this.count;
        this.el.count.classList.remove('is-pop');
        void this.el.count.offsetWidth;
        this.el.count.classList.add('is-pop');
        const msg = this.messages[this.count];
        if (msg) this.el.message.textContent = msg;
        if (navigator.vibrate) navigator.vibrate(12);
        this.loop();
      }

      loop() {
        if (this.running) return;
        this.running = true;
        const tick = () => {
          const active = this.step();
          this.render();
          if ((active || this.pressed) && this.visible) {
            this.raf = requestAnimationFrame(tick);
          } else {
            this.running = false;
          }
        };
        this.raf = requestAnimationFrame(tick);
      }

      step() {
        const stiffness = this.reduced ? 0.25 : 0.14;
        const damping = this.reduced ? 0.6 : 0.82;

        // Écrasement global (ressort amorti, avec rebond).
        const targetSquash = this.pressed ? 1 : 0;
        this.squashV += (targetSquash - this.squash) * (this.pressed ? 0.22 : 0.12);
        this.squashV *= this.reduced ? 0.5 : 0.78;
        this.squash += this.squashV;

        // Étirement horizontal quand on tire.
        const targetStretch = this.pressed && this.pointer ? Math.max(-1, Math.min(1, (this.pointer.x - this.pressStart) / 140)) : 0;
        this.stretchV += (targetStretch - this.stretch) * 0.15;
        this.stretchV *= 0.8;
        this.stretch += this.stretchV;

        const sq = this.squash;
        const sx = 1 + sq * 0.16;
        const sy = 1 - sq * 0.2;
        const restCY = BASE_Y - RY * 0.62 * sy;

        let energy = Math.abs(this.squashV) + Math.abs(this.stretchV);
        for (const p of this.points) {
          let tx = CX + p.rx * sx + this.stretch * 26 * (p.ry < 0 ? 1 : 0.3);
          let ty = restCY + p.ry * sy;
          // Creux sous le doigt.
          if (this.pressed && this.pointer) {
            const dx = p.x - this.pointer.x;
            const dy = p.y - this.pointer.y;
            const d = Math.hypot(dx, dy) || 1;
            if (d < 90) {
              const push = (1 - d / 90) * 26;
              tx += (dx / d) * push * 0.4;
              ty += Math.max(0, push * 0.9);
            }
          }
          // Pas sous le sol.
          ty = Math.min(ty, BASE_Y + 2);
          p.vx = (p.vx + (tx - p.x) * stiffness) * damping;
          p.vy = (p.vy + (ty - p.y) * stiffness) * damping;
          p.x += p.vx;
          p.y += p.vy;
          energy += Math.abs(p.vx) + Math.abs(p.vy);
        }
        return energy > 0.05;
      }

      path() {
        // Courbe fermée lissée (Catmull-Rom → Bézier).
        const pts = this.points;
        let d = `M ${pts[0].x.toFixed(1)} ${pts[0].y.toFixed(1)}`;
        for (let i = 0; i < N; i++) {
          const p0 = pts[(i - 1 + N) % N];
          const p1 = pts[i];
          const p2 = pts[(i + 1) % N];
          const p3 = pts[(i + 2) % N];
          const c1x = p1.x + (p2.x - p0.x) / 6;
          const c1y = p1.y + (p2.y - p0.y) / 6;
          const c2x = p2.x - (p3.x - p1.x) / 6;
          const c2y = p2.y - (p3.y - p1.y) / 6;
          d += ` C ${c1x.toFixed(1)} ${c1y.toFixed(1)}, ${c2x.toFixed(1)} ${c2y.toFixed(1)}, ${p2.x.toFixed(1)} ${p2.y.toFixed(1)}`;
        }
        return d + ' Z';
      }

      render() {
        const pts = this.points;
        const top = pts[0];
        let cx = 0;
        let cy = 0;
        for (const p of pts) {
          cx += p.x;
          cy += p.y;
        }
        cx /= N;
        cy /= N;
        const h = BASE_Y - top.y;
        const sq = Math.max(0, this.squash);
        const faceY = top.y + h * 0.58;
        const spread = 46 * (1 + sq * 0.18);

        this.el.body.setAttribute('d', this.path());
        this.el.pleats.setAttribute(
          'd',
          `M ${top.x} ${top.y + 4} q -10 22 -30 34 M ${top.x} ${top.y + 4} v 38 M ${top.x} ${top.y + 4} q 10 22 30 34`
        );
        this.el.shine.setAttribute('cx', (cx - 50).toFixed(1));
        this.el.shine.setAttribute('cy', (top.y + h * 0.28).toFixed(1));
        this.el.shadow.setAttribute('rx', (120 * (1 + sq * 0.25)).toFixed(1));
        this.el.shadow.setAttribute('cx', cx.toFixed(1));

        // Les yeux suivent légèrement le curseur.
        let lookX = 0;
        let lookY = 0;
        const target = this.pointer || this.hover;
        if (target) {
          lookX = Math.max(-4, Math.min(4, (target.x - cx) / 30));
          lookY = Math.max(-3, Math.min(3, (target.y - faceY) / 30));
        }
        const ex = (side) => cx + side * spread;
        this.el.eyeL.setAttribute('cx', ex(-1));
        this.el.eyeL.setAttribute('cy', faceY);
        this.el.eyeR.setAttribute('cx', ex(1));
        this.el.eyeR.setAttribute('cy', faceY);
        this.el.glintL.setAttribute('cx', ex(-1) + 3 + lookX);
        this.el.glintL.setAttribute('cy', faceY - 4 + lookY);
        this.el.glintR.setAttribute('cx', ex(1) + 3 + lookX);
        this.el.glintR.setAttribute('cy', faceY - 4 + lookY);

        const closed = sq > 0.35;
        this.el.open.style.display = closed ? 'none' : '';
        this.el.closed.style.display = closed ? '' : 'none';
        this.el.closed.setAttribute(
          'd',
          `M ${ex(-1) - 12} ${faceY - 6} l 12 6 l -12 6 M ${ex(1) + 12} ${faceY - 6} l -12 6 l 12 6`
        );
        const mouthW = 14 + sq * 8;
        this.el.mouth.setAttribute(
          'd',
          closed
            ? `M ${cx - mouthW} ${faceY + 20} q ${mouthW} ${18} ${mouthW * 2} 0`
            : `M ${cx - 12} ${faceY + 20} q 12 12 24 0`
        );
        this.el.cheekL.setAttribute('cx', ex(-1) - 16);
        this.el.cheekL.setAttribute('cy', faceY + 20);
        this.el.cheekR.setAttribute('cx', ex(1) + 16);
        this.el.cheekR.setAttribute('cy', faceY + 20);
        const blush = (0.55 + sq * 0.4).toFixed(2);
        this.el.cheekL.setAttribute('opacity', blush);
        this.el.cheekR.setAttribute('opacity', blush);
      }
    }
    customElements.define('sq-squeeze', SqSqueeze);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sq-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sq-image-slider')) {
    class SqImageSlider extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.track = this.querySelector('.sq-videos__track');
        this.slides = [...this.querySelectorAll('.sq-videos__slide')];
        this.dots = this.querySelector('.sq-videos__dots');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;
        if (!this.track || this.slides.length === 0) return;

        this.querySelectorAll('.sq-videos__arrow').forEach((button) => {
          button.addEventListener('click', () => this.go(Number(button.dataset.dir)), { signal });
        });

        // Points de navigation.
        if (this.dots && this.slides.length > 1) {
          this.slides.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.className = 'sq-videos__dot';
            this.dots.appendChild(dot);
          });
        }
        this.track.addEventListener('scroll', () => this.updateDots(), { passive: true, signal });
        this.updateDots();

        // Pause au survol, au toucher et au focus clavier.
        const pause = () => (this.paused = true);
        const resume = () => (this.paused = false);
        this.addEventListener('pointerenter', pause, { signal });
        this.addEventListener('pointerleave', resume, { signal });
        this.addEventListener('focusin', pause, { signal });
        this.addEventListener('focusout', resume, { signal });
        this.track.addEventListener('touchstart', pause, { passive: true, signal });

        if (this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1) {
          const delay = Math.max(2, Number(this.dataset.speed) || 4) * 1000;
          this.timer = setInterval(() => {
            if (!this.paused && document.visibilityState === 'visible') this.go(1, true);
          }, delay);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearInterval(this.timer);
      }

      step() {
        const slide = this.slides[0];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.offsetWidth + gap;
      }

      go(direction, loop = false) {
        const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const atEnd = Math.abs(this.track.scrollLeft) >= max;
        const behavior = this.reduced ? 'auto' : 'smooth';
        if (loop && direction > 0 && atEnd) {
          this.track.scrollTo({ left: 0, behavior });
          return;
        }
        this.track.scrollBy({ left: direction * rtl * this.step(), behavior });
      }

      updateDots() {
        if (!this.dots) return;
        const index = Math.round(Math.abs(this.track.scrollLeft) / this.step());
        [...this.dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }
    customElements.define('sq-image-slider', SqImageSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
